/**
 * Created with zhengchao04 on 2018-08-21 11:33:19.
 * Description: 业务类型（厂商开通的渠道）
 *
 * @author zhengchao04@meituan.com
 * @version 1.0.0
 */
export const bizTypeEnums = {
  10: '点餐',
  20: '排队'
};



// WEBPACK FOOTER //
// ./src/config/bizTypeEnums.js